import '../../css/filterComponent.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import React, { useEffect, useState, useRef } from 'react';
import SearchComponent from '../searchComponent';

const FilterComponent = ({ filter, multipleAllowedBool, searchableBool, onSelect, clear }) => {
  const [open, setOpen] = useState(false);
  const [dropdownTop, setDropdownTop] = useState(undefined)
  const [search, setSearch] = useState('');
  const [visibleList, setVisibleList] = useState()
  const [title, setTitle] = useState('')
  const [selectedValues, setSelectedValues] = useState([])
  const [openUp, setOpenUp] = useState(false);
  const dropdownRef = useRef();
  const buttonRef = useRef();
  const contentRef = useRef();

  useEffect(()=> {
    const handler = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)){
        setOpen(false);
        if (!multipleAllowedBool && selectedValues && selectedValues.length > 0){
          setTitle(selectedValues[0].value)
        }
      }
    };  
    document.addEventListener("click", handler)

    return () => {
      document.removeEventListener("click", handler)
    };
  }, [dropdownRef,selectedValues])

  useEffect(() => {
    if (filter.optionsList)
      setVisibleList( filter.optionsList.filter(label => label.value.toLowerCase().includes(search.toString().toLowerCase())) )
  }, [search])

  useEffect(() => {
    setVisibleList(filter.optionsList)
  }, [filter])

  useEffect(() => {
    onSelect(filter, []);
    setSelectedValues([]);
    setTitle(filter.filterName);
  }, [clear])

  useEffect(() => {
    setTitle(filter.filterName)
  }, [])


  const toggleDropdown = () => {
    if (!open){
      const root = document.getElementById('root');
      const rootRect = root.getBoundingClientRect();

      const buttonRect = buttonRef.current.getBoundingClientRect();
      
      const spaceBelow = rootRect.bottom - buttonRect.bottom;
      const spaceAbove = buttonRect.top - rootRect.top;
      const contentHeight = contentRef.current.scrollHeight;

      if (spaceBelow >= contentHeight) {
        setDropdownTop(buttonRef.current.offsetHeight);
        setOpenUp(false);
      } else if (spaceAbove >= contentHeight) {
        setDropdownTop(-contentHeight - 8); 
        setOpenUp(true);
      } else {
        setDropdownTop(spaceAbove < spaceBelow ? buttonRef.current.offsetHeight : -contentHeight);        
        setOpenUp(spaceAbove < spaceBelow);
      }
      setTitle(filter.filterName);
    } else {
      if (!multipleAllowedBool && selectedValues && selectedValues.length > 0){
        setTitle(selectedValues[0].value)
      }
      
    }
    setOpen(open => !open);
  };

  const selectItem = (item) => {
    if (multipleAllowedBool){
      const values = selectedValues.filter(x=> x.key !== item.key);
      if (values.length === selectedValues.length){
        values.push(item)
      }
      onSelect(filter, values);
      setSelectedValues(values);
    } else {
      if (item === selectedValues[0]){
        onSelect(filter, []);
        setSelectedValues([]);
        setTitle(filter.filterName);
      } else {
        onSelect(filter, [item]);
        setSelectedValues([item]);
        setTitle(item.value);
        setOpen(false);
      }
    }
  }

  function isSelected(item){
    if (selectedValues){
      return selectedValues?.find(x=> x.key === item.key);
    }

    return false;
  }

  return (
    <div className = "component" ref = {dropdownRef}>
      <div ref={buttonRef} onClick={toggleDropdown} className={`dropdown-button cursor-pointer px-4 py-2 ${open || selectedValues.length > 0 ? "button-open" : "button-closed"}`}>
        <div className = ""> {title} </div>
        <div className = "ml-2 toggleIcon">
          {open ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
        </div>
      </div>
      <div ref={contentRef} className={`dropdown-content z-[500] px-4 py-2 ${open ? "content-open" : null} ${openUp ? "" : "mt-2"}`} style={{
        position: "absolute",
        top: dropdownTop !== undefined ? `${dropdownTop}px` : undefined,
        left: 0
      }}>
        {searchableBool ?
          <SearchComponent
            searchClass='bg-white px-4 py-2 border rounded-md mb-2 flex flex-row items-center'
            onSearchChange={(event) => setSearch(event)}>
          </SearchComponent> : null}
        <div> 
          {visibleList ? visibleList.map((item) => (
            <div className ={`dropdown-item ${isSelected(item) ? 'dropdown-item-selected' : ''}`}  onClick={() => selectItem(item)} key={item.key}>
              {item.value}
              <div className = {isSelected(item) ? "showCheck ml-2" : "no-show-check"}>
                {<FontAwesomeIcon icon={faCheck} />}
              </div>
            </div>
          )) : null}
          
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
